import { SIZEINPUT_CHANGED_VALUE, SIZEINPUT_CLEAR_DATA, SIZEINPUT_SETDEFAULT_DATA } from '../Actions/PurchaseMultiSizeInput.action';

const defaultState = {
    data: [],
    defaultData: [],
}

export const sizeInput = (state = defaultState, action) => {
    switch (action.type) {
        case SIZEINPUT_CHANGED_VALUE: 
            return {
                ...state,
                ...action.payload,
            }
        case SIZEINPUT_CLEAR_DATA: 
            return {
                ...state,
                data: JSON.parse(JSON.stringify(state.defaultData)),
            }
        case SIZEINPUT_SETDEFAULT_DATA:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}
